export const PUBLIC_URL = "https://letsdecorateapp.com";
export const DEV_URL = "http://localhost:8100";

/** PRODUCTION */

export const PARSE_SERVER_URL = "https://letsdecorate.back4app.io";
export const PARSE_APP_ID = "W4f2B4g4iM635LZKAdf4adf65ZWEZ2f9bMXR5x59";
export const PARSE_JS_ID = "qsQ7Bmfey7mwsxdLURceDSg5gxrsXYFjaA6ibjGz";
export const STRIPE_PUBLISHABLE_KEY = "pk_live_51H71VtHX7Wjx7cAmIXiL72njVm7DrZp9axsR8Q6J1pUM7VVT6ygJ94JOr7VD603Jj0NTidcmO3y456GT5ZwCYG1c00451IiVLN";
export const STRIPE_SECRET_KEY = "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";

/** DEVELOPMENT MODE */

// export const PARSE_SERVER_URL = "https://letsdecoratetest.b4a.io/";
// export const PARSE_APP_ID = "jvw3HODSnivx6aGn1meoeQKZvEnRmn4Xeo86tXTb";
// export const PARSE_JS_ID = "jAYpxP5MIuODBO6n4fHSZ3Wqi5Fdnd2USAIiVIxg";
// export const STRIPE_PUBLISHABLE_KEY = "pk_test_51H71VtHX7Wjx7cAmSKQ7Ki5aK1HO7AAGEOYlfZtbfXhAfMW8G6OyEy45cIfjmUO9JJI8bVW2tDz49Owim41MqsWh00aWGcJqUr";
// export const STRIPE_SECRET_KEY = "sk_test_51H71VtHX7Wjx7cAmJaWEENftrYjrBSUsiWbIBARZNdt19sBVodNiIvo1E8IVxOqY4UVVilEzix5TfXwu8ekABuCK0020qCb1Rt";

